module.exports = __webpack_public_path__ + "static/img/8.2aa69aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/companyLogo-f/8.jpg
// module id = X1dk
// module chunks = 0